(function(){
  if(window.__ddHeaderControls)return;window.__ddHeaderControls=true;
  var frame=0;
  function update(){
    frame=0;
    document.querySelectorAll('.dd-hm__btn,.dd-hm__home,.dd-cart-bubble').forEach(function(control){
      var r=control.getBoundingClientRect(),x=Math.min(innerWidth-1,Math.max(0,r.left+r.width/2)),y=Math.min(innerHeight-1,Math.max(0,r.top+r.height/2));
      var under=document.elementsFromPoint(x,y).find(function(el){return !el.closest('.dd-hm,.dd-cart-bubble,#PBarNextFrameWrapper,#shopify-pc__banner')&&el!==document.documentElement&&el!==document.body;});
      var tone='light';
      if(under){
        var surface=under.closest('[data-scheme],.dd-ne,.dd-hero,.dd-brand-banner,.dd-footer,.color-scheme-dark,.dd-plp__editorial');
        if(surface){
          var scheme=surface.getAttribute('data-scheme');
          if(scheme==='dark'||(!scheme&&surface.matches('.dd-ne,.dd-brand-banner,.dd-footer,.color-scheme-dark,.dd-plp__editorial')))tone='dark';
        }
        if(under.closest('.dd-splash__slide--dark'))tone='dark';
      }
      var hero=document.querySelector('.dd-splash');
      if(hero){var heroRect=hero.getBoundingClientRect();if(r.top<heroRect.bottom&&r.bottom>heroRect.top)tone='dark';}
      if(control.closest('.dd-hm')&&document.querySelector('[data-dd-hm-panel][aria-hidden="false"]'))tone='dark';
      if(control.dataset.ddNavTone!==tone)control.dataset.ddNavTone=tone;
    });
  }
  function queue(){if(!frame)frame=requestAnimationFrame(update);}
  function boot(){update();addEventListener('scroll',queue,{passive:true});addEventListener('resize',queue,{passive:true});document.addEventListener('load',queue,true);document.addEventListener('shopify:section:load',queue);new MutationObserver(queue).observe(document.body,{subtree:true,attributes:true,attributeFilter:['data-scheme','aria-hidden']});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();